<template>
  <div class="mall">
    <div class="content">
      <div class="user" v-show="userInfo.id">
        <img class="avatar" :src="userInfo.avatar" alt="" />
        <div class="name">
          <div>{{ userInfo.nick_name }}</div>
          <img :src="userLevel(userInfo.level)" alt="" />
        </div>
        <div class="title">
          <div>我的钱包</div>
          <div class="btn" @click="toRecharge">充值</div>
        </div>
        <div class="amount">
          <div class="diamond">
            <div class="left">
              <div class="up">{{ $bigNumber(userInfo.diamond / 100) }}</div>
              <div class="down">克拉</div>
            </div>
            <img src="./img/diamond.png" alt="" />
          </div>
          <div class="diamond gold">
            <div class="left">
              <div class="up">{{ $bigNumber(userInfo.gold / 100) }}</div>
              <div class="down">鹰钻</div>
            </div>
            <img src="./img/gold.png" alt="" />
          </div>
        </div>
        <div class="history">
          <div class="left" @click="openHistory">
            <img src="./img/history.png" alt="" />
            <div>购买记录</div>
          </div>
          <div class="left" @click="toService">
            <img src="./img/service.png" alt="" />
            <div>在线客服</div>
          </div>
        </div>
      </div>
      <div class="wrap">
        <div class="title">
          <img src="./img/title.png" alt="" />
        </div>
        <div class="list" v-if="mallItems.length > 0">
          <div :class="['item', index === 0 ? 'item-active' : '']" v-for="(item, index) in mallItems" :key="index">
            <div class="logo">
              <img :src="item.thumb" alt="" />
              <!-- <div class="mark" v-if="item.limit === 0">永久</div>
              <div class="mark mark1" v-else>{{ item.limit }}天</div> -->
            </div>
            <div class="item-right">
              <div class="desc">
                <div class="desc-a">
                  <div class="name">{{ item.title }}</div>
                  <div class="discount" v-show="userInfo.noble_id > 0">
                    <img src="./img/discount.png" alt="" />
                    <div>贵族折扣 {{ userInfo.gift_discount }}%</div>
                  </div>
                </div>
                <div class="desc-b">
                  <img v-show="item.diamond" src="./img/diamond.png" alt="" />
                  <span v-show="item.diamond">{{ item.diamond / 100 }}</span>
                  <img v-show="item.gold" src="./img/gold.png" alt="" />
                  <span v-show="item.gold">{{ item.gold / 100 }}</span>
                </div>
              </div>
              <div class="btn" @click="openPayConfirmy(item)">立即购买</div>
            </div>
          </div>
        </div>
        <div class="empty-list" v-else>
          <img src="@/assets/img/empty/no-data1.png" alt="" />
          <div>空空如也～</div>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="storeHistoryDialog">
      <div class="store-history">
        <div class="header">
          <div>购买记录</div>
          <img src="./img/close.png" @click="storeHistoryDialog = false" alt="" />
        </div>
        <div class="history-content">
          <div class="list" v-for="(item, index) in storeHistory" :key="index">
            <div class="list-up">
              <div class="logo">
                <img :src="item.thumb" alt="" />
              </div>
              <div class="desc">
                <div class="desc-up">
                  <div class="left">{{ item.title }}</div>
                  <div class="right">{{ format(item.created_at * 1000, "MM-dd hh:mm") }}</div>
                </div>
                <div class="desc-down">
                  <div class="left" v-show="item.diamond > 0">
                    <img src="./img/diamond.png" alt="" />
                    <div>{{ item.diamond / 100 }}</div>
                  </div>
                  <div class="left" v-show="item.gold > 0">
                    <img src="./img/gold.png" alt="" />
                    <div>{{ item.gold / 100 }}</div>
                  </div>
                  <!-- <div class="right" v-show="item.type === 1">已发送</div> -->
                  <div class="right" v-show="item.status === 1">已发货</div>
                  <div class="right" style="color: #ffba39" v-show="item.status === 0">未发货</div>
                </div>
              </div>
            </div>
            <div class="list-down share-copy" :data-clipboard-text="item.express_no" @click="copy()" v-show="item.express_no">快递单号：{{ item.express_no }}</div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="payConfirmDialog">
      <div class="pay-confirm">
        <div class="close">
          <img @click="payConfirmDialog = false" src="./img/close.png" alt="" />
        </div>
        <div class="row1">
          <img :src="payConfirmItem.thumb" alt="" />
        </div>
        <div class="row2">{{ payConfirmItem.title }}</div>
        <!-- <div class="row3" v-show="payConfirmItem.limit > 0">有效期 {{ payConfirmItem.limit }}天</div>
        <div class="row3" v-show="payConfirmItem.limit === 0">有效期 永久</div> -->
        <div class="row4">
          <div @click="pay(2)" class="btn btn-active" v-show="payConfirmItem.diamond && payConfirmItem.gold">鹰钻购买</div>
          <div @click="pay(2)" class="btn" v-show="payConfirmItem.gold && payConfirmItem.diamond === 0">鹰钻购买</div>
          <div @click="pay(1)" class="btn" v-show="payConfirmItem.diamond">克拉购买</div>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="" :visible.sync="chargeDiamond" class="first-gift-dialog">
      <div class="charge-diamond">
        <div class="row1">您的克拉余额不足</div>
        <div class="row3">
          <div class="btn" @click="chargeDiamond = false">取消</div>
          <div class="btn btn-active" @click="goChargeDiamond">立即充值</div>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="" :visible.sync="chargeGold" class="first-gift-dialog">
      <div class="charge-diamond charge-gold">
        <div class="row1">
          <p>您的鹰钻余额不足</p>
          <p>做任务赚取鹰钻</p>
        </div>
        <div class="row3">
          <div class="btn" @click="chargeGold = false">取消</div>
          <div class="btn btn-active" @click="goChargeGold">做任务</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import { post } from "../../util/http";
import Footer from "@/components/footer/footer";
import Cipboard from "clipboard";
import { userLevel } from "@/util/level-icon";
import { format } from "@/util/time";
export default {
  name: "mall",
  components: {},
  computed: {
    ...mapState(["userInfo", "appConfig"]),
  },
  props: {},

  data() {
    return {
      page: 1,
      size: 99,
      total: 0,
      mallItems: [],
      storeHistoryDialog: false,
      storeHistory: [],
      payType: 1,
      payConfirmDialog: false,
      payConfirmItem: {},
      chargeDiamond: false,
      chargeGold: false,
      isPaying: false,
    };
  },
  created() {},
  destroyed() {},
  mounted() {
    this.getMallItems();
  },
  methods: {
    ...mapMutations(["toggleLogin"]),
    ...mapActions(["getUserInfo"]),
    userLevel,
    format,
    copy() {
      let copyBtn = new Cipboard(".share-copy");
      copyBtn.on("success", () => {
        this.showToast(this.$t("room-intro.copy-successfully"));
      });
    },
    goChargeDiamond() {
      this.$router.push("/user-center/recharge");
    },
    goChargeGold() {
      this.$router.push("/home");
    },
    openPayConfirmy(item) {
      if (!this.userInfo.id) {
        this.toggleLogin();
        return;
      }
      this.payConfirmDialog = true;
      this.payConfirmItem = item;
      console.log(item);
    },
    getStoreHistory() {
      post({
        url: "/api/live/store_order_list",
        data: { page: 1, size: 10, uid: this.userInfo.id },
      })
        .then(({ data }) => {
          console.log(data, "data");
          if (data.status === 0) {
            this.storeHistory = data.data.live_store_order_list;
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    openHistory() {
      if (!this.userInfo.id) {
        this.toggleLogin();
        return;
      }
      this.storeHistoryDialog = true;
      this.getStoreHistory();
    },
    toRecharge() {
      if (!this.userInfo.id) {
        this.toggleLogin();
        return;
      }
      this.$router.push("/user-center/recharge");
    },
    toService() {
      window.open(this.appConfig.service_url, "_blank");
    },
    getMallItems() {
      post({
        url: "/api/live/store",
        data: { page: this.page, size: this.size },
      })
        .then((res) => {
          this.mallItems = res.data.data.live_store;
          this.total = res.data.data.total;
          console.log(this.mallItems, "data");
        })
        .catch((e) => {
          console.log(e);
        });
    },
    pay(payType) {
      console.log(payType, this.userInfo.diamond, this.payConfirmItem?.diamond, this.userInfo.gift_discount);
      let discount = this.userInfo.gift_discount ? this.userInfo.gift_discount / 100 : 1;
      if (this.userInfo.diamond < this.payConfirmItem?.diamond * discount && payType === 1) {
        this.payConfirmDialog = false;
        this.chargeDiamond = true;
        return;
      }
      if (this.userInfo.gold < this.payConfirmItem?.gold * discount && payType === 2) {
        this.payConfirmDialog = false;
        this.chargeGold = true;
        return;
      }
      this.isPaying = true;
      post({
        url: "/api/live/store_order",
        data: { id: this.payConfirmItem?.id, uid: this.userInfo.id, pay_type: payType },
      })
        .then(({ data: { data } }) => {
          if (data.status === 1) {
            this.$message.success("购买成功");
          } else if (data.status === 2) {
            this.$message.error("购买失败");
          } else if (data.status === 3) {
            this.$message.error("余额不足");
          } else if (data.status === 4) {
            this.$message.error("支付方式错误");
          }
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          this.payConfirmDialog = false;
          this.isPaying = false;
          this.getUserInfo();
        });
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep {
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 0;
  }
  .el-dialog {
    width: 0;
    display: flex;
    justify-content: center;

    margin-top: 0 !important;
    position: absolute;
    top: 45%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
.store-history {
  width: 4.38rem;
  display: flex;
  flex-direction: column;
  border-radius: 0.1rem;
  background: #ffffff;
  .header {
    height: 0.64rem;
    padding: 0 0.3rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 0.2rem;
    color: #333333;
    box-shadow: inset 0px -0.5px 0px #f0f0f0;
    img {
      width: 0.16rem;
      height: 0.16rem;
      cursor: pointer;
    }
  }
  .history-content {
    padding: 0 0.3rem;
    margin-bottom: 0.4rem;
    max-height: 6.9rem;
    overflow: scroll;
    .list {
      display: flex;
      flex-direction: column;
      padding: 0.2rem 0 0.1rem 0.1rem;
      box-shadow: inset 0px -0.5px 0px rgba(0, 0, 0, 0.1);
      .list-up {
        display: flex;
        margin-bottom: 0.1rem;
        .logo {
          width: 0.48rem;
          height: 0.48rem;
          background: #ffffff;
          border: 0.5px solid #dcdcdc;
          box-shadow: 1px 2px 5px rgba(0, 0, 0, 0.03);
          border-radius: 0.08rem;
          padding: 0 0.05rem;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-right: 0.15rem;
          img {
            width: 100%;
          }
        }
        .desc {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 0.03rem 0;
          .desc-up {
            display: flex;
            align-items: center;
            justify-content: space-between;
            // margin-bottom: 0.08rem;
            .left {
              font-weight: 500;
            }
            .right {
              font-size: 0.12rem;
              color: #999999;
            }
          }
          .desc-down {
            display: flex;
            align-items: center;
            justify-content: space-between;
            .left {
              display: flex;
              font-size: 0.12rem;
              color: #666666;
              img {
                width: 0.16rem;
                margin-right: 0.03rem;
              }
            }
            .right {
              font-size: 12px;
              color: #02a8a2;
            }
          }
        }
      }
      .list-down {
        font-size: 0.12rem;
        color: #999999;
        cursor: pointer;
      }
    }
  }
}
.pay-confirm {
  width: 4rem;
  display: flex;
  align-items: center;
  flex-direction: column;
  border-radius: 0.1rem;
  background: #ffffff;
  .close {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    img {
      width: 0.16rem;
      height: 0.16rem;
      margin: 0.2rem 0.2rem 0 0;
      cursor: pointer;
    }
  }
  .row1 {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 1rem;
    margin-bottom: 0.2rem;
    margin-top: 0.2rem;
    img {
      height: 100%;
    }
  }
  .row2 {
    font-size: 0.18rem;
    color: #333333;
  }
  .row3 {
    font-size: 0.16rem;
    color: #999999;
    margin-top: 0.1rem;
  }
  .row4 {
    display: flex;
    margin-bottom: 0.4rem;
    margin-top: 0.3rem;
    gap: 0.24rem;
    .btn {
      width: 1.12rem;
      height: 0.34rem;
      background: #02a8a2;
      border-radius: 0.34rem;
      font-size: 0.16rem;
      color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
    .btn-active {
      background: #ffffff;
      color: #02a8a2;
      border: 0.01rem solid #02a8a2;
    }
  }
}
.charge-diamond {
  width: 3.55rem;
  height: 1.64rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 0.4rem 0 0.28rem;
  border-radius: 0.1rem;
  background: #ffffff;
  .row1 {
    font-size: 0.16rem;
    color: #333333;
    text-align: center;
    line-height: 0.22rem;
  }
  .row3 {
    display: flex;
    align-items: center;
    justify-content: center;
    .btn {
      width: 1.12rem;
      height: 0.34rem;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #666666;
      font-size: 0.16rem;
      color: #02a8a2;
      border: 1px solid #02a8a2;
      border-radius: 1rem;
      cursor: pointer;
    }
    .btn-active {
      background: #02a8a2;
      color: #ffffff;
      margin-left: 0.24rem;
    }
  }
}
.charge-gold {
  height: 1.86rem;
}
.mall {
  margin-top: 0.66rem;
  background: url("./img/banner.png") no-repeat;
  background-size: 100%;
  background-color: #f9f9fb;

  .content {
    width: 14rem;
    margin: 4.33rem auto 0.5rem;
    position: relative;
    .user {
      width: 3rem;
      height: 3.4rem;
      background: #ffffff;
      border-radius: 0.1rem;
      position: absolute;
      top: -3.64rem;
      right: 0.2rem;
      display: flex;
      flex-direction: column;
      padding: 0 0.16rem;
      background-clip: padding-box, border-box;
      background-origin: padding-box, border-box;
      background-image: linear-gradient(to right, #fff, #fff), linear-gradient(180deg, #baff84 0%, #bae7ff 100%);
      border: 0.04rem solid transparent;
      .avatar {
        width: 0.6rem;
        height: 0.6rem;
        border-radius: 0.6rem;
        background-clip: padding-box, border-box;
        background-origin: padding-box, border-box;
        background-image: linear-gradient(to right, #fff, #fff), linear-gradient(90deg, #29f19c 0%, #02a1f9 100%);
        border: 1px solid transparent;
        margin: 0.28rem auto 0.1rem;
      }
      .name {
        display: flex;
        align-items: center;
        justify-content: center;
        color: #333333;
        font-weight: 500;
        margin-bottom: 0.24rem;
        img {
          height: 0.18rem;
          margin-left: 0.03rem;
        }
      }
      .title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #333333;
        font-size: 0.12rem;
        margin-bottom: 0.1rem;
        .btn {
          width: 0.48rem;
          height: 0.21rem;
          background: #02a8a2;
          border-radius: 0.2rem;
          color: #ffffff;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
        }
      }
      .amount {
        display: flex;
        justify-content: space-between;
        .diamond {
          width: 1.26rem;
          height: 0.53rem;
          background: linear-gradient(90deg, #ecffec 0%, #dffffd 100%);
          border-radius: 0.05rem;
          padding: 0.08rem;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .left {
            color: #333333;
            .up {
              font-weight: 700;
              font-size: 0.16rem;
              margin-bottom: 0.03rem;
            }
            .down {
              font-size: 0.12rem;
            }
          }
          img {
            width: 0.3rem;
            height: 0.3rem;
          }
        }
        .gold {
          background: linear-gradient(90deg, #fff3c9 0%, #ffede6 100%);
        }
      }
      .history {
        display: flex;
        justify-content: space-around;
        height: 0.74rem;
        margin-top: 0.2rem;
        .left {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          cursor: pointer;
          img {
            width: 0.52rem;
            height: 0.52rem;
          }
        }
      }
    }
    .wrap {
      width: 14rem;
      background: #ffffff;
      border-radius: 0.2rem;
      padding: 0.4rem;
      .title {
        img {
          height: 0.2rem;
          margin-bottom: 0.3rem;
        }
      }
      .empty-list {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        min-height: 7rem;
        font-size: 0.18rem;
        color: #999999;
        img {
          width: 1.8rem;
          height: 1.8rem;
        }
      }
      .list {
        // min-height: 7rem;
        display: flex;
        flex-wrap: wrap;
        gap: 0.3rem;
        .item {
          width: 4.2rem;
          height: 1.7rem;
          border-radius: 0.05rem;
          background: #f9f9fb;
          display: flex;
          padding: 0.1rem;
          .logo {
            width: 1.5rem;
            height: 1.5rem;
            background: #ffffff;
            border-radius: 0.05rem;
            display: flex;
            justify-content: center;
            align-items: center;
            position: relative;
            img {
              max-width: 1.2rem;
              max-height: 1.5rem;
            }
            .mark {
              width: 0.4rem;
              height: 0.2rem;
              background: linear-gradient(105.88deg, #ffd501 0%, #ff9101 100%);
              border-radius: 0px 0.05rem;
              position: absolute;
              top: 0;
              right: 0;
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: 0.12rem;
              color: #ffffff;
            }
            .mark1 {
              background: linear-gradient(111.45deg, #f05555 0%, #f17c4a 100%);
            }
          }
          .item-right {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            padding: 0.1rem 0;
            margin-left: 0.2rem;
            .desc {
              .desc-a {
                display: flex;
                align-items: center;
                .name {
                  font-size: 0.16rem;
                  font-weight: 600;
                }
                .discount {
                  min-width: 1.1rem;
                  height: 0.2rem;
                  border-radius: 0 0 0.1rem 0;
                  border-image: linear-gradient(90deg, #ffd600 0%, #ff8f00 100%);
                  background-clip: padding-box, border-box;
                  background-origin: padding-box, border-box;
                  background-image: linear-gradient(to right, #fff7e6, #fff7e6), linear-gradient(90deg, #ffd600 0%, #ff8f00 100%);
                  border: 1px solid transparent;
                  display: flex;
                  align-items: center;
                  margin-left: 0.1rem;
                  padding: 0 0.05rem;
                  color: #ffbb00;
                  font-size: 0.12rem;
                  img {
                    width: 0.16rem;
                    margin-right: 0.03rem;
                  }
                }
              }
              .desc-b {
                display: flex;
                align-items: center;
                font-size: 0.12rem;
                color: #666666;
                margin-top: 0.08rem;
                img {
                  width: 0.16rem;
                  margin-right: 0.03rem;
                }
                span {
                  margin-right: 0.08rem;
                }
              }
            }
            .btn {
              width: 0.96rem;
              height: 0.32rem;
              background: linear-gradient(90deg, #29f19c 0%, #02a1f9 100%);
              border-radius: 0.32rem;
              color: #ffffff;
              display: flex;
              justify-content: center;
              align-items: center;
              cursor: pointer;
            }
          }
        }
        .item:hover {
          border-image: linear-gradient(90deg, #29f19c 0%, #02a1f9 100%);
          background-clip: padding-box, border-box;
          background-origin: padding-box, border-box;
          background-image: linear-gradient(to right, #fff, #fff), linear-gradient(90deg, #29f19c 0%, #02a1f9 100%);
          border: 1px solid transparent;
          box-shadow: 0px 0.04rem 0.04rem rgba(2, 168, 162, 0.1);
        }
      }
    }
  }
}
</style>
